import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CategoryFormPage from "./CategoryFormPage";

const ViewCategoryPage = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb for page title and navigation */}
      <Breadcrumb
        id="title"
        title2="Categories"
        link2="/categories"
        title="Category Edit"
      />

      
      <CategoryFormPage />
    </MasterLayout>
  );
};

export default ViewCategoryPage;
